import { render, staticRenderFns } from "./AnnotationList.vue?vue&type=template&id=0240ddfe&scoped=true&"
import script from "./AnnotationList.vue?vue&type=script&lang=js&"
export * from "./AnnotationList.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationList.vue?vue&type=style&index=0&id=0240ddfe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0240ddfe",
  null
  
)

export default component.exports